import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../constants/componentTypes";
import * as databaseStatuses from "../../../constants/databaseStatuses";
import * as translationHelper from "../../../helpers/translationHelper";

import CustomIcon from "../../global/CustomIcon";

import imgUpdate from "../../../resources/img/svgicons/arrow-up-circle.svg";
import imgSkip from "../../../resources/img/svgicons/skip.svg";

export default class UpdateDatabasesPanel extends Component {
    NUMBER_OF_UPDATES = 3;

    intervalId = null;

    constructor(props) {
        super(props);

        this.state = {
            countdown: 15
        };
    }

    closeInterval = () => {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;

            this.setState({
                countdown: -1
            });
        }
    };

    componentDidMount() {
        if (this.intervalId === null && !this.props.setupSoftware && !this.props.loading) {
            this.setState({countdown: 15});

            let self = this;
            this.intervalId = setInterval(function () {
                if (self.state.countdown === 1) {
                    if (self.props.databaseList.length > 0 && self.props.numberOfUpdates >= self.NUMBER_OF_UPDATES) {
                        self.props.getAllDatabaseListAndSkipUpdate();
                    } else {
                        self.props.updateDatabases();
                    }
                    self.closeInterval();
                } else {
                    self.setState({
                        countdown: self.state.countdown - 1
                    });
                }
            }, 1000);
        }
    }

    componentWillUnmount() {
        this.closeInterval();
    }

    handleUpdateDatabaseClick = () => {
        this.closeInterval();
        this.props.updateDatabases();
    };

    handleStopUpdateClick = () => {
        this.closeInterval();
    };

    handleSkipUpdateClick = () => {
        this.closeInterval();
        this.props.getAllDatabaseListAndSkipUpdate();
    };

    getUpdateDatabaseTitle = () => {
        if (this.props.loading) {
            if (this.props.updateDatabaseList.length > 1) {
                return translate("welcome.updatingDatabases") + "...";
            }

            return translate("welcome.updatingDatabase") + "...";
        }

        if (this.props.updateDatabaseList.length > 1) {
            return translate("welcome.databasesCompatibility");
        }

        if (this.props.updateDatabaseList.length === 1) {
            return translate("welcome.databaseCompatibility");
        }

        return translate("welcome.availableDatabase");
    };

    getDbStatus = (key, db) => {
        return (
            <tr key={key} className="server-row blue">
                <td>
                    <div>{db.name}</div>
                </td>
                <td>
                    <div>{translationHelper.getDbStatusTranslation(db.status)}</div>
                </td>
            </tr>
        );
    };

    getInvalidDbStatus = (key, db) => {
        return (
            <tr key={key} className="server-row blue disabled">
                <td>
                    <div>{db.name}</div>
                </td>
                <td>
                    <div>{translationHelper.getDbStatusTranslation(db.status)}</div>
                </td>
            </tr>
        );
    };

    getDatabaseStatuses = () => {
        let statusList = [];
        let key = 0;

        for (let db of this.props.updateDatabaseList) {
            if (db !== null) {
                statusList.push(this.getDbStatus(key, db));
                key++;
            }
        }

        for (let db of this.props.invalidDatabaseList) {
            if (
                db !== null &&
                db.status !== databaseStatuses.MAIN_AND_LOCAL_UPDATE_NEEDED &&
                db.status !== databaseStatuses.MAIN_UPDATE_NEEDED &&
                db.status !== databaseStatuses.MAIN_PARTIAL_UPDATE_AND_LOCAL_UPDATE_NEEDED &&
                db.status !== databaseStatuses.MAIN_PARTIAL_UPDATE_NEEDED &&
                db.status !== databaseStatuses.LOCAL_UPDATE_NEEDED
            ) {
                statusList.push(this.getInvalidDbStatus(key, db));
                key++;
            }
        }

        return statusList;
    };

    getDatabaseUpdateButton = () => {
        if (this.props.loading) {
            return "";
        }

        if (this.props.numberOfUpdates >= this.NUMBER_OF_UPDATES && this.props.databaseList.length > 0) {
            return (
                <button
                    className="btn btn-md btn-info pull-right"
                    onClick={this.handleUpdateDatabaseClick}
                    style={{marginLeft: "15px"}}
                >
                    <ReactSVG src={imgUpdate} alt="update" className="pull-left btn-icon svg-icon" />
                    <Translate value="welcome.updateDatabase" />
                </button>
            );
        }

        if (this.props.setupSoftware || this.state.countdown < 1) {
            return (
                <button
                    className="btn btn-md btn-info pull-right"
                    onClick={this.handleUpdateDatabaseClick}
                    style={{marginLeft: "15px"}}
                >
                    <ReactSVG src={imgUpdate} alt="update" className="pull-left btn-icon svg-icon" />
                    <Translate value="welcome.updateDatabase" />
                </button>
            );
        }

        return (
            <button
                className="btn btn-md btn-info pull-right"
                onClick={this.handleUpdateDatabaseClick}
                style={{marginLeft: "15px"}}
            >
                <ReactSVG src={imgUpdate} alt="update" className="pull-left btn-icon svg-icon" />
                <Translate value="welcome.updateDatabase" /> ({this.state.countdown})
            </button>
        );
    };

    getStopUpdateButton = () => {
        if (this.props.loading || this.props.setupSoftware || this.state.countdown < 1) {
            return "";
        }

        if (this.props.numberOfUpdates < this.NUMBER_OF_UPDATES || this.props.databaseList.length === 0) {
            return (
                <button
                    className="btn btn-md btn-info pull-right"
                    onClick={this.handleStopUpdateClick}
                    style={{marginLeft: "15px"}}
                >
                    <Translate value="welcome.stopUpdate" />
                </button>
            );
        }

        return "";
    };

    getSkipUpdateButton = () => {
        if (this.props.loading || this.props.setupSoftware || this.props.databaseList.length === 0) {
            return "";
        }

        if (this.props.numberOfUpdates >= this.NUMBER_OF_UPDATES && this.state.countdown > 0) {
            return (
                <button
                    className="btn btn-md btn-info pull-right"
                    onClick={this.handleSkipUpdateClick}
                    style={{marginLeft: "15px"}}
                >
                    <ReactSVG src={imgSkip} alt="option" className="pull-left btn-icon svg-icon" />
                    <Translate value="general.skip" /> ({this.state.countdown})
                </button>
            );
        }

        return (
            <button
                className="btn btn-md btn-info pull-right"
                onClick={this.handleSkipUpdateClick}
                style={{marginLeft: "15px"}}
            >
                <ReactSVG src={imgSkip} alt="option" className="pull-left btn-icon svg-icon" />
                <Translate value="general.skip" />
            </button>
        );
    };

    getButtons = () => {
        return (
            <div className="col-xs-12 text-right update-db-btn-row">
                {this.getDatabaseUpdateButton()}
                {this.getStopUpdateButton()}
                {this.getSkipUpdateButton()}
            </div>
        );
    };

    getContent = () => {
        if (this.props.loading) {
            return (
                <div className="slim-scroll col-xs-12 server-table">
                    <div>
                        <div className="col-xs-12 update-warning">
                            <Translate value="welcome.updatingWarning" />
                        </div>
                        <div className="col-xs-12 update-warning-info">
                            <Translate value="welcome.updatingWarningInfo" />
                        </div>
                        <div className="col-xs-12">
                            <CustomIcon iconType={componentTypes.ICON_LOADER} className="loader" alt="loading" />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="col-xs-12 server-table slim-scroll">
                <table>
                    <thead>
                        <tr>
                            <th className="color-primary">
                                <Translate value="general.database" />
                            </th>
                            <th className="color-primary">
                                <Translate value="general.note" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{this.getDatabaseStatuses()}</tbody>
                </table>
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="col-xs-12 select-server-text">{this.getUpdateDatabaseTitle()}</div>
                {this.getContent()}
                {this.getButtons()}
            </React.Fragment>
        );
    }
}
